export default {
    mobile: {
        create: [
            {
                action: "annotate",
                title: "Highlight",
                label: "Annotate",
                icon: "#si-entypo-brush",
                tool: "create",
            },
            {
                action: "tags",
                title: "Tags",
                label: "Tags",
                icon: "#si-awesome-tags",
                tool: "create"
            },
            {
                action: "copy",
                title: "Copy",
                label: "Copy",
                icon: "#si-entypo-copy",
                tool: "create"
            },
            {
                action: "notebook",
                title: "Add To Notebook",
                label: "Add to",
                icon: "#si-entypo-book",
                tool: "create"
            },
            // {
            //     action: "help",
            //     title: "Help",
            //     label: "Help",
            //     icon: "#si-entypo-help",
            //     tool: "create"
            // }
        ],
        tags: [
            {
                action: "tags",
                title: "Close",
                icon: "#si-entypo-back",
                tool: "tags"
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Facts",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "facts",
                tagid: 1
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Issues",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "issues",
                tagid: 2
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Ruling",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "ruling",
                tagid: 3
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Principles",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "principles",
                tagid: 4
            }
        ],
        edit: [
            {
                action: "tags",
                title: "Tag",
                label: "Tags",
                icon: "#si-awesome-tags",
                tool: "edit"
            },
            {
                action: "comment",
                title: "Comment",
                label: "Comment",
                icon: "#si-awesome-comment",
                tool: "edit"
            },
            {
                action: "notebook",
                title: "Add To Notebook",
                label: "Add to",
                icon: "#si-entypo-book",
                tool: "edit"
            },
            {
                action: "erase",
                title: "Erase",
                label: "Erase",
                icon: "#si-bootstrap-erase",
                tool: "edit"
            }
        ]
    },
    web: {
        create: [
            {
                action: "annotate",
                title: "Tag",
                label: "Facts",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "facts",
                tagid: 1
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Issues",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "issues",
                tagid: 2
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Ruling",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "ruling",
                tagid: 3
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Principles",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "principles",
                tagid: 4
            },
            {
                action: "notebook",
                title: "Add To Notebook",
                label: "Add to",
                icon: "#si-entypo-book",
                tool: "tags"
            }
        ],
        edit: [
            {
                action: "tags",
                title: "Tag",
                label: "Tags",
                icon: "#si-awesome-tags",
                tool: "edit"
            },
            {
                action: "comment",
                title: "Comment",
                label: "Comment",
                icon: "#si-awesome-comment",
                tool: "edit"
            },
            {
                action: "notebook",
                title: "Add To Notebook",
                label: "Add to",
                icon: "#si-entypo-book",
                tool: "edit"
            },
            {
                action: "erase",
                title: "Erase",
                label: "Erase",
                icon: "#si-bootstrap-erase",
                tool: "edit"
            }
        ],
        tags: [
            {
                action: "tags",
                title: "Close",
                icon: "#si-entypo-back",
                tool: "tags"
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Facts",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "facts",
                tagid: 1
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Issues",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "issues",
                tagid: 2
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Ruling",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "ruling",
                tagid: 3
            },
            {
                action: "annotate",
                title: "Tag",
                label: "Principles",
                icon: "#si-awesome-tag",
                tool: "tags",
                tag: "principles",
                tagid: 4
            }
        ]
    },
    law: {
        mobile: {
            create: [
                {
                    action: "annotate",
                    title: "Highlight",
                    label: "Highlight",
                    icon: "#si-entypo-brush",
                    tag: "facts",
                    tool: "create",
                },
                {
                    action: "copy",
                    title: "Copy",
                    label: "Copy",
                    icon: "#si-entypo-copy",
                    tool: "create"
                },
                {
                    action: "notebook",
                    title: "Add To Notebook",
                    label: "Add to",
                    icon: "#si-entypo-book",
                    tool: "create"
                },
                // {
                //     action: "help",
                //     title: "Help",
                //     label: "Help",
                //     icon: "#si-entypo-help",
                //     tool: "create"
                // }
            ],
            edit: [
                {
                    action: "comment",
                    title: "Comment",
                    label: "Comment",
                    icon: "#si-awesome-comment",
                    tool: "edit"
                },
                {
                    action: "notebook",
                    title: "Add To Notebook",
                    label: "Add to",
                    icon: "#si-entypo-book",
                    tool: "edit"
                },
                {
                    action: "erase",
                    title: "Erase",
                    label: "Erase",
                    icon: "#si-bootstrap-erase",
                    tool: "edit"
                }
            ]
        }, web: {
            create: [
                {
                    action: "annotate",
                    title: "Highlight",
                    label: "Highlight",
                    icon: "#si-entypo-brush",
                    tag: "facts",
                    tool: "create",
                },
                {
                    action: "notebook",
                    title: "Add To Notebook",
                    label: "Add to",
                    icon: "#si-entypo-book",
                    tool: "create"
                }
            ],
            edit: [
                {
                    action: "comment",
                    title: "Comment",
                    label: "Comment",
                    icon: "#si-awesome-comment",
                    tool: "edit"
                },
                {
                    action: "notebook",
                    title: "Add To Notebook",
                    label: "Add to",
                    icon: "#si-entypo-book",
                    tool: "edit"
                },
                {
                    action: "erase",
                    title: "Erase",
                    label: "Erase",
                    icon: "#si-bootstrap-erase",
                    tool: "edit"
                }
            ]
        }
    }
}